import classnames from 'classnames';
import VideoItem, { VideoItemProps } from 'components/helpers/VideoItem/VideoItem';
import getThemeClasses from 'lib/util/theming';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
// import { Data } from '.generated/templates/Feature.Data.model';
import { RichTextField, TextField } from '@sitecore-jss/sitecore-jss-react';
import RichTextA11yWrapper from '../RichTextA11yWrapper';
import Button from '../Button';
import { getCardTopBorderClass } from './card-utils';
import { OnLinkDataLayerPush } from 'lib/util/gtm-datalayer';

interface VideoCardProps {
  promotedPage: VideoItemProps;
  isSingleCard: boolean;
  onGtmPush?: OnLinkDataLayerPush;
}

const VideoCard = ({ promotedPage, isSingleCard, onGtmPush }: VideoCardProps): JSX.Element => {
  const SingleCard = classnames({ 'lg:hidden': isSingleCard });
  const cardTopBorderClass = getCardTopBorderClass().concat(' ').concat(SingleCard);

  if (!promotedPage) {
    return <></>;
  }
  return (
    <>
      <div className={classnames('callout-card-img')}>
        <div
          className={classnames(
            'col-span-2',
            'md:col-span-1',
            'lg:col-span-2',
            'md:grid-cols-2',
            'lg:grid-cols-3'
          )}
        >
          <VideoItem {...promotedPage} hideVideoContent />
        </div>
      </div>
      <div
        className={classnames('callout-card-content', 'max-h-full', getThemeClasses('theme-white'))}
      >
        <span className={cardTopBorderClass} />
        <span className={classnames('cc-border-bottom')} />
        <div className={classnames('mt-7')}>
          <Text
            className={classnames('heading-md', 'max-w-prose', 'mb-4')}
            tag="h2"
            field={promotedPage.fields.videoTitle as TextField}
          />
          <RichTextA11yWrapper
            className={classnames('p-0', 'rte')}
            field={promotedPage.fields.videoDescription as RichTextField}
          />
        </div>
        <div className={classnames('cta-container')}>
          <Button
            linkField={promotedPage.fields.cta}
            className={classnames('mr-2', 'sm:mr-4')}
            onGtmPush={onGtmPush}
          />
          <Button linkField={promotedPage.fields.cta2} variant="secondary" onGtmPush={onGtmPush} />
        </div>
      </div>
    </>
  );
};

export default VideoCard;
